export default "__VITE_ASSET__DqdCme39__"